import React, { useEffect, useState } from 'react';
import API_URL from '../../config';
import './LegalPage.css';

// P1 — LGPD. Página pública que renderiza um documento legal (Política
// de Privacidade ou Termos de Uso) servido pelo backend em /api/legal/*.
// Acessível sem login — App.jsx roteia /privacidade e /termos para cá.

const DOCS = {
  privacy: { endpoint: '/api/legal/privacy-policy', titulo: 'Política de Privacidade' },
  terms: { endpoint: '/api/legal/terms-of-use', titulo: 'Termos de Uso' },
};

function formatarData(iso) {
  // "2026-04-15" -> "15/04/2026"
  if (!iso || typeof iso !== 'string') return '';
  const partes = iso.split('-');
  if (partes.length !== 3) return iso;
  const [ano, mes, dia] = partes;
  return `${dia}/${mes}/${ano}`;
}

function BlocoContato({ contato }) {
  return (
    <div className="legal-contato">
      {contato.nome && <p className="legal-contato-nome">{contato.nome}</p>}
      {contato.email && (
        <p>
          <a href={`mailto:${contato.email}`}>{contato.email}</a>
        </p>
      )}
      {contato.endereco && <p>{contato.endereco}</p>}
    </div>
  );
}

function Secao({ valor }) {
  // Uma seção pode vir como string solta (ex.: "introducao") ou como
  // objeto { titulo, descricao?, itens?, contato? }.
  if (typeof valor === 'string') {
    return <p className="legal-paragrafo legal-intro">{valor}</p>;
  }
  if (!valor || typeof valor !== 'object') return null;

  return (
    <section className="legal-secao">
      {valor.titulo && <h2 className="legal-secao-titulo">{valor.titulo}</h2>}
      {valor.descricao && <p className="legal-paragrafo">{valor.descricao}</p>}
      {Array.isArray(valor.itens) && valor.itens.length > 0 && (
        <ul className="legal-lista">
          {valor.itens.map((item, i) => (
            <li key={i}>{item}</li>
          ))}
        </ul>
      )}
      {valor.contato && <BlocoContato contato={valor.contato} />}
    </section>
  );
}

function LegalPage({ doc }) {
  const cfg = DOCS[doc] || DOCS.privacy;
  const [data, setData] = useState(null);
  const [erro, setErro] = useState(false);

  useEffect(() => {
    let cancelado = false;
    setData(null);
    setErro(false);
    fetch(`${API_URL}${cfg.endpoint}`)
      .then((r) => {
        if (!r.ok) throw new Error(`HTTP ${r.status}`);
        return r.json();
      })
      .then((d) => {
        if (!cancelado) setData(d);
      })
      .catch(() => {
        if (!cancelado) setErro(true);
      });
    return () => {
      cancelado = true;
    };
  }, [cfg.endpoint]);

  return (
    <div className="legal-page">
      <header className="legal-header">
        <a href="/" className="legal-voltar"><span className="material-symbols-outlined" style={{ fontSize: '15px', verticalAlign: 'text-bottom' }}>arrow_back</span> Voltar para o Qaa.sa</a>
      </header>

      <main className="legal-conteudo">
        {erro && (
          <div className="legal-aviso">
            Não foi possível carregar o documento. Tente recarregar a página.
          </div>
        )}

        {!erro && !data && <div className="legal-aviso">Carregando…</div>}

        {data && (
          <article className="legal-documento">
            <h1 className="legal-titulo">{data.title || cfg.titulo}</h1>
            <p className="legal-meta">
              Versão {data.version} · Atualizado em {formatarData(data.updated_at)}
            </p>
            {data.content &&
              Object.entries(data.content).map(([chave, valor]) => (
                <Secao key={chave} valor={valor} />
              ))}
          </article>
        )}
      </main>

      <footer className="legal-rodape">
        <p>Qaa.sa — Quality as a Service</p>
        <p className="legal-rodape-links">
          <a href="/privacidade">Política de Privacidade</a>
          <span aria-hidden="true"> · </span>
          <a href="/termos">Termos de Uso</a>
        </p>
      </footer>
    </div>
  );
}

export default LegalPage;
